export default class {
    constructor ($q, $state, $translate, SkillResource, ModalService) {
        this.$q = $q;
        this.$state = $state;
        this.$translate = $translate;
        this.SkillResource = SkillResource;
        this.ModalService = ModalService;
    }

    /**
     * Check if skill is connected to APGs and show confirmation if needed.
     * Returns a promise that resolves with { proceed: true/false, affectedApgs: [] }
     */
    checkAndConfirm (skillId) {
        const deferred = this.$q.defer();

        this.SkillResource.affectedApgs({ id: skillId }).$promise
            .then((result) => {
                const count = result && result.count ? result.count : 0;
                const apgs = result && result.affectedApgs ? result.affectedApgs : [];
                const courseSkills = result && result.courseSkills ? result.courseSkills : [];
                if (count > 0 && apgs.length > 0 || courseSkills.length > 0) {
                    // Show confirmation modal
                    this.showConfirmationModal(apgs, courseSkills)
                        .then(() => deferred.resolve({ proceed: true, affectedApgs: apgs }))
                        .catch(() => deferred.resolve({ proceed: false, affectedApgs: apgs }));
                }
                else {
                    // No affected APGs, proceed without confirmation
                    deferred.resolve({ proceed: true, affectedApgs: [] });
                }
            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    /**
     * Show the APG confirmation modal
     */
    showConfirmationModal (affectedApgs, courseSkills) {
        const apgListHtml = (affectedApgs || []).map(apg => {
            const url = this.$state.href('authorized.courses.courses.edit.occurrence.automated.edit.targets', {
                id: apg.course_id,
                planningGroupId: apg.id
            });
            const name = apg.name || `${this.$translate.instant('skill.Planning group')} #${apg.id}`;
            return `<li><a href="${url}" target="_blank"><strong>${name}</strong></a></li>`;
        }).join('');

        const coursesListHtml = (courseSkills || []).map(course => {
            const url = this.$state.href('authorized.courses.courses.edit.version.edit.training', {
                id: course.course.id,
                versionId: course.course_version_id,
                tab: 'skills'
            });
            const name = `${course.course.activeI18n.name} - ${course.courseVersion.name}`;
            return `<li><a href="${url}" target="_blank"><strong>${name}</strong></a></li>`;
        }).join('');

        let message = '';

        if (affectedApgs && affectedApgs.length > 0) {
            message += `
            <p>${this.$translate.instant('skill.SkillApgWarningMessage')}</p>
            <ul class="mt10">${apgListHtml}</ul>`;
        }

        if (courseSkills && courseSkills.length > 0) {
            message += `
            <p>${this.$translate.instant('skill.SkillCoursesWarningMessage')}</p>
            <ul class="mt10">${coursesListHtml}</ul>`;
        }

        message += `
            <p class="mt10">${this.$translate.instant('skill.SkillApgWarningEffect')}</p>
            <p class="mt10">${this.$translate.instant('skill.SkillApgConfirmQuestion')}</p>
        `;

        return this.ModalService.confirm(message, 'medium');
    }

    /**
     * Check if skill has any connected APGs (without showing modal)
     */
    hasConnectedApgs (skillId) {
        return this.SkillResource.affectedApgs({ id: skillId }).$promise
            .then((result) => {
                const count = result && result.count ? result.count : 0;
                return count > 0;
            })
            .catch(() => false);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/skill/activation/index.js